import { StreamingPlayerTypography } from '@heardis/stream-contracts';
import { useState, useEffect } from 'react';
import WarningIcon from '../../elements/icons/WarningIcon';
import { AnalyticsEventType } from '../../hooks/analytics/analytics.types';
import useAnalytics from '../../hooks/analytics/useAnalytics';
import InfoContainer from './InfoContainer';
import classes from './ErrorContainer.module.css';

type ErrorContainerProps = {
  error?: number;
  backgroundColor: string;
  typography: StreamingPlayerTypography;
};

function ErrorContainer({ error, backgroundColor, typography }: ErrorContainerProps) {
  const [errorCode, setErrorCode] = useState<number | null>(null);
  const { trackAnalyticsEvent } = useAnalytics();

  useEffect(() => {
    if (error) {
      setErrorCode(error);
    }
  }, [error]);

  return (
    <InfoContainer backgroundColor={backgroundColor} typography={typography}>
      <h2 className={classes.errorContainerTitle}>
        <WarningIcon />
        Unexpected Error
      </h2>
      <p>
        We are sorry for that unexpected error. Click
        {' '}
        <button
          type="button"
          className={classes.errorContainerButton}
          onClick={() => {
            document.location.reload();
            trackAnalyticsEvent({ type: AnalyticsEventType.PAGE_RELOAD });
          }}
        >
          here
        </button>
        {' '}
        to reload the player. If the problem still exists consult our
        {' '}
        <a className={classes.link} href="https://www.heardis.com/en/" target="_blank" rel="noopener noreferrer">support</a>
        .
      </p>
      <small>
        {`Error: ${errorCode}`}
      </small>
    </InfoContainer>
  );
}

export default ErrorContainer;
